/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // FIX: Forzar submit del formulario de idioma/país en header
  document.addEventListener('DOMContentLoaded', function() {
    const headerLocalizationForms = document.querySelectorAll('header .localization-form, header form[action="/localization"]');
    
    headerLocalizationForms.forEach(function(form) {
      const options = form.querySelectorAll('.select-popout__option[data-popout-option]');
      
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Obtener el valor seleccionado
          const value = this.getAttribute('data-value');
          
          // Actualizar el input hidden correspondiente
          const hiddenInput = form.querySelector('input[data-popout-input]');
          if (hiddenInput && value) {
            hiddenInput.value = value;
          }
          
          // Forzar submit del formulario
          setTimeout(function() {
            form.submit();
          }, 100);
        });
      });
    });
  });





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
